import { render, staticRenderFns } from "./SlideBox.vue?vue&type=template&id=05821e5e"
import script from "./SlideBox.vue?vue&type=script&lang=js"
export * from "./SlideBox.vue?vue&type=script&lang=js"
import style0 from "./SlideBox.vue?vue&type=style&index=0&id=05821e5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports